var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"temporary-transfer-pill t3 -t_medium"},[_c('sword-icon-wuk',{attrs:{"name":"hourglass"}}),_vm._v(" "+_vm._s(_vm.formatDate(_vm.startDate))+" - "+_vm._s(_vm.formatDate(_vm.endDate))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }